const tipos = ['image/png', 'image/jpeg', 'image/webp'];
export function tituloArquivo(arquivo) {
  return (arquivo?.name || 'Print').replace(/\.[^.]+$/, '').slice(0, 80) || 'Print';
}
export function imagemTransferida(transferencia) {
  const arquivo = Array.from(transferencia?.files || []).find(f => tipos.includes(f.type));
  if (arquivo) return arquivo;
  const item = Array.from(transferencia?.items || []).find(i => tipos.includes(i.type));
  return item?.getAsFile() || null;
}
